import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import {
  FaSearch,
  FaMapMarkedAlt,
  FaInfoCircle,
  FaChevronLeft,
  FaChevronRight,
} from 'react-icons/fa';

// ==============================
// IMPORTAÇÃO DOS SVGs (agrupados por tipo)
// ==============================

// --- MOTO (5) ---
import Moto1 from '../assets/icons/home/1.1-moto-amarela.svg';
import Moto2 from '../assets/icons/home/1.2-moto-azul.svg';
import Moto3 from '../assets/icons/home/1.3-moto-amarela.svg';
import Moto4 from '../assets/icons/home/1.4-moto-laranja.svg';
import Moto5 from '../assets/icons/home/1.5-moto-cinza.svg';

// --- TXOPELA (4) ---
import Txopela1 from '../assets/icons/home/2.1-txopela-yellow.svg';
import Txopela2 from '../assets/icons/home/2.2-txopela-yellow.svg';
import Txopela3 from '../assets/icons/home/2.3-txopela-orange.svg';
import Txopela4 from '../assets/icons/home/2.4-txopela-greenyellow.svg';

// --- LIGEIRO (5) ---
import Ligeiro1 from '../assets/icons/home/3.1-ligeiro-yellow.svg';
import Ligeiro2 from '../assets/icons/home/3.2-ligeiro-blue.svg';
import Ligeiro3 from '../assets/icons/home/3.3-ligeiro-orange.svg';
import Ligeiro4 from '../assets/icons/home/3.4-ligeiro-prata.svg';
import Ligeiro5 from '../assets/icons/home/3.5-ligeiro-yellow.svg';

// --- PICKUP (6) ---
import Pickup1 from '../assets/icons/home/4.1-pickup-blue.svg';
import Pickup2 from '../assets/icons/home/4.2-pickup-green.svg';
import Pickup3 from '../assets/icons/home/4.3-pickup-black.svg';
import Pickup4 from '../assets/icons/home/4.4-pickup-white.svg';
import Pickup5 from '../assets/icons/home/4.5-pickup-brown.svg';
import Pickup6 from '../assets/icons/home/4.6-pickup-yellow.svg';

// --- VAN (5) ---
import Van1 from '../assets/icons/home/5.1-van-whithe.svg';
import Van2 from '../assets/icons/home/5.2-van-yelow.svg';
import Van3 from '../assets/icons/home/5.3-van-blue.svg';
import Van4 from '../assets/icons/home/5.4-van-yelow.svg';
import Van5 from '../assets/icons/home/5.5-van-blue.svg';

// --- TRUCK SMALL (3) ---
import TruckSmall1 from '../assets/icons/home/6.1-truck-small.svg';
import TruckSmall2 from '../assets/icons/home/6.2-truck-small.svg';
import TruckSmall3 from '../assets/icons/home/6.3-truck-small.svg';

// --- TRUCK MEDIUM (4) ---
import TruckMedium1 from '../assets/icons/home/7.1-truck-medium.svg';
import TruckMedium2 from '../assets/icons/home/7.2-truck-medium.svg';
import TruckMedium3 from '../assets/icons/home/7.3-truck-medium.svg';
import TruckMedium4 from '../assets/icons/home/7.4-truck-medium.svg';

// --- TRUCK LARGE (3) ---
import TruckLarge1 from '../assets/icons/home/8.1-truck-bigblue.svg';
import TruckLarge2 from '../assets/icons/home/8.2-truck-bigblue.svg';
import TruckLarge3 from '../assets/icons/home/8.3-truck-bigblue.svg';

import img1 from '../assets/images/homescroll/homescroll1.jpg';
import img2 from '../assets/images/homescroll/homescroll2.jpg';
import img3 from '../assets/images/homescroll/homescroll3.jpg';
import img4 from '../assets/images/homescroll/homescroll4.jpg';
import img5 from '../assets/images/homescroll/homescroll5.jpg';

import './Home.css';

// ==============================
// AGRUPAMENTO DOS ÍCONES POR ID
// ==============================
const vehicleIconGroups = {
  moto: [Moto1, Moto2, Moto3, Moto4, Moto5],
  txopela: [Txopela1, Txopela2, Txopela3, Txopela4],
  sedan: [Ligeiro1, Ligeiro2, Ligeiro3, Ligeiro4, Ligeiro5],
  pickup: [Pickup1, Pickup2, Pickup3, Pickup4, Pickup5, Pickup6],
  van: [Van1, Van2, Van3, Van4, Van5],
  truck_small: [TruckSmall1, TruckSmall2, TruckSmall3],
  truck_medium: [TruckMedium1, TruckMedium2, TruckMedium3, TruckMedium4],
  truck_large: [TruckLarge1, TruckLarge2, TruckLarge3],
};

// ==============================
// TYPING TEXT COMPONENT
// ==============================
const TypingText = ({ text, speed = 100, pause = 4000, onComplete }) => {
  const [displayed, setDisplayed] = useState('');

  useEffect(() => {
    let index = 0;
    let timer;
    const type = () => {
      if (index <= text.length) {
        setDisplayed(text.slice(0, index));
        index++;
        timer = setTimeout(type, speed);
      } else {
        if (onComplete) onComplete();
      }
    };
    timer = setTimeout(type, speed);
    return () => clearTimeout(timer);
  }, [text, speed, pause, onComplete]);

  return <>{displayed}</>;
};

// ==============================
// VEHICLE CARD COM CARROSSEL AUTOMÁTICO
// ==============================
const VehicleCard = ({ vehicle }) => {
  const icons = vehicleIconGroups[vehicle.id] || [];
  const [currentIndex, setCurrentIndex] = useState(0);

  // Reseta quando o veículo muda
  useEffect(() => {
    setCurrentIndex(0);
  }, [vehicle.id]);

  // Troca automática a cada 5 segundos
  useEffect(() => {
    if (icons.length <= 1) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % icons.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [icons.length]);

  const IconComponent = icons.length > 0 ? icons[currentIndex] : null;

  return (
    <div className="vehicle-card" key={vehicle.id}>
      {vehicle.badge && (
        <span className="vehicle-badge" style={{ backgroundColor: vehicle.color }}>
          {vehicle.badge}
        </span>
      )}
      <div className="vehicle-icon">
        {IconComponent ? (
          <img
            src={IconComponent}
            alt={vehicle.name}
            className="vehicle-icon-img"
          />
        ) : (
          <span className="vehicle-icon-fallback">🚚</span>
        )}
      </div>
      <h3 className="vehicle-name">{vehicle.name}</h3>
      <p className="vehicle-capacity"><strong>{vehicle.capacity}</strong></p>
      <p className="vehicle-volume">{vehicle.volume}</p>
      <p className="vehicle-example">📦 {vehicle.example}</p>
    </div>
  );
};

// ==============================
// COMPONENTE PRINCIPAL HOME
// ==============================
const Home = () => {
  const { t } = useTranslation();
  const [typingStep, setTypingStep] = useState(1);

  const [currentSlide, setCurrentSlide] = useState(0);
  const slideIntervalRef = useRef(null);

  const slides = [
    {
      src: img1,
      alt: 'Mulher com iPhone ao lado do carro',
      subtitle: 'Solicite um motorista com apenas um toque.'
    },
    {
      src: img2,
      alt: 'Casal com tablet e caixa dentro de casa',
      subtitle: 'Acompanhe a sua carga em tempo real.'
    },
    {
      src: img3,
      alt: 'Jovens a descarregar uma mesa para um casal',
      subtitle: 'Mudanças e móveis? Nós transportamos.'
    },
    {
      src: img4,
      alt: 'Jovem a falar ao telefone encostada ao veículo',
      subtitle: 'Estamos sempre disponíveis para si.'
    },
    {
      src: img5,
      alt: 'Compras na parte traseira de um veículo',
      subtitle: 'Entregas de compras e encomendas, à sua porta.'
    }
  ];

  // Auto‑play do carrossel principal
  useEffect(() => {
    slideIntervalRef.current = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 10000);

    return () => {
      if (slideIntervalRef.current) {
        clearInterval(slideIntervalRef.current);
        slideIntervalRef.current = null;
      }
    };
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
    if (slideIntervalRef.current) {
      clearInterval(slideIntervalRef.current);
      slideIntervalRef.current = null;
    }
    slideIntervalRef.current = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 10000);
  };

  const nextSlide = () => goToSlide((currentSlide + 1) % slides.length);
  const prevSlide = () => goToSlide((currentSlide - 1 + slides.length) % slides.length);

  const onTypingComplete = useCallback(() => {
    if (typingStep === 1) {
      setTimeout(() => {
        setTypingStep(2);
      }, 5000);
    }
  }, [typingStep]);

  // DADOS DOS VEÍCULOS (sem o campo 'icon' – usamos o grupo)
  const VEHICLES = [
    {
      id: 'moto',
      name: 'Moto',
      capacity: 'Até 20 kg',
      volume: 'Volume mínimo',
      example: 'Documentos, pequenas encomendas',
      color: '#3B82F6',
      badge: 'Entrega rápida',
    },
    {
      id: 'txopela',
      name: 'Txopela',
      capacity: 'Até 80 kg',
      volume: 'Pequeno volume',
      example: 'Sacos, compras, caixas leves',
      color: '#22C55E',
      badge: 'Muito usado',
    },
    {
      id: 'sedan',
      name: 'Viatura ligeira',
      capacity: 'Até 300 kg',
      volume: '1–2 m³',
      example: 'Caixas, pequenas mudanças',
      color: '#8B5CF6',
    },
    {
      id: 'pickup',
      name: 'Pickup',
      capacity: 'Até 1.000 kg',
      volume: '2–4 m³',
      example: 'Materiais, móveis pequenos',
      color: '#F97316',
      badge: 'Mais usado',
    },
    {
      id: 'van',
      name: 'Carrinha / Van',
      capacity: 'Até 1.500 kg',
      volume: '4–8 m³',
      example: 'Mudanças médias',
      color: '#0127fd',
      badge: 'Mais espaço',
    },
    {
      id: 'truck_small',
      name: 'Camião leve',
      capacity: 'Até 3.000 kg',
      volume: '8–12 m³',
      example: 'Carga leve',
      color: '#EAB308',
      badge: 'Ideal para mudanças',
    },
    {
      id: 'truck_medium',
      name: 'Camião médio',
      capacity: 'Até 5.000 kg',
      volume: '12–20 m³',
      example: 'Carga média pesada',
      color: '#3B82F6',
      badge: 'Grandes cargas',
    },
    {
      id: 'truck_large',
      name: 'Camião pesado',
      capacity: 'Até 15 toneladas',
      volume: '20m³+',
      example: 'Carga industrial',
      color: '#fa0eaf',
      badge: 'Ideal grandes obras',
    },
  ];

  return (
    <div className="home">
      <div className="hero-section">
        <div className="carousel-container hero-carousel">
          <div
            className="carousel-track"
            style={{
              transform: `translateX(-${currentSlide * (100 / slides.length)}%)`
            }}
          >
            {slides.map((slide, idx) => (
              <div className="carousel-slide" key={idx}>
                <img src={slide.src} alt={slide.alt} loading="lazy" />
              </div>
            ))}
          </div>

          <button className="carousel-btn prev" onClick={prevSlide} aria-label="Anterior">
            <FaChevronLeft />
          </button>
          <button className="carousel-btn next" onClick={nextSlide} aria-label="Seguinte">
            <FaChevronRight />
          </button>

          <div className="carousel-dots">
            {slides.map((_, idx) => (
              <button
                key={idx}
                className={`dot ${idx === currentSlide ? 'active' : ''}`}
                onClick={() => goToSlide(idx)}
                aria-label={`Ir para o slide ${idx + 1}`}
              />
            ))}
          </div>
        </div>

        <div className="hero-content">
          <h1>
            {typingStep >= 1 && (
              <TypingText
                text={t('Conectamos donos de cargas a motoristas de confiança')}
                speed={70}
                pause={5000}
                onComplete={onTypingComplete}
              />
            )}
          </h1>
          <p key={currentSlide} className="slide-subtitle">
            {slides[currentSlide].subtitle}
          </p>
        </div>
      </div>

      {/* SEÇÃO DE VEÍCULOS COM CARROSSEL DE ÍCONES */}
      <div className="content-section vehicles-section">
        <h2>{t('Tipos de Veículos')}</h2>
        <p className="section-subtitle">
          Escolha o veículo certo para a sua carga
        </p>
        <div className="vehicles-grid">
          {VEHICLES.map((vehicle) => (
            <VehicleCard key={vehicle.id} vehicle={vehicle} />
          ))}
        </div>
      </div>

      <div className="content-section">
        <h2>{t('Como Funciona o Carga Fácil')}</h2>
        <div className="steps-container">
          <div className="step">
            <FaSearch className="step-icon" />
            <h3>{t('Solicite um Motorista')}</h3>
            <p>{t('Encontre motoristas disponíveis próximos a você.')}</p>
          </div>
          <div className="step">
            <FaMapMarkedAlt className="step-icon" />
            <h3>{t('Acompanhe em Tempo Real')}</h3>
            <p>{t('Monitore o transporte da sua carga em tempo real até o destino.')}</p>
          </div>
        </div>
      </div>

      <div className="content-section">
        <Link to="/sobre" className="about-link">
          <h2>{t('Sobre o Carga Fácil')}</h2>
          <div className="about-container">
            <FaInfoCircle className="about-icon" />
            <p>{t('O Carga Fácil é uma plataforma inovadora que conecta donos de carga a motoristas de confiança.')}</p>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default Home;